<template>
  <Header />
  <AipathHomeUpgrade />
  <Footer />
</template>

<script>
import Header from "../../components/system/SiteHeader.vue";
import AipathHomeUpgrade from "../../components/Home/AipathHomeUpgrade.vue";
import Footer from "../../components/system/SiteFooter.vue";

export default {
  name: "HomePage",
  components: {
    Header,
    AipathHomeUpgrade,
    Footer,
  },
};
</script>
<style>
h1,
h2,
h3,
h4,
h5 {
  text-transform: none !important;
}
</style>
